import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "property-default" }
const _hoisted_2 = { class: "ontos-field-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_toggle = _resolveComponent("v-btn-toggle")!
  const _component_ontos_instance_property_input = _resolveComponent("ontos-instance-property-input")!
  const _component_ontos_formula_input = _resolveComponent("ontos-formula-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$tt('default-value')), 1),
    _createVNode(_component_v_btn_toggle, {
      "model-value": _ctx.mode,
      mandatory: "",
      divided: "",
      density: "comfortable",
      variant: "outlined",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.choose($event)))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MODES, (option) => {
          return (_openBlock(), _createBlock(_component_v_btn, {
            key: option,
            value: option
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$tt(`default-mode.${option}`)), 1)
            ]),
            _: 2
          }, 1032, ["value"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["model-value"]),
    (_ctx.mode === 'fixed')
      ? (_openBlock(), _createBlock(_component_ontos_instance_property_input, {
          key: 0,
          class: _normalizeClass(["property-default-field", {'property-default-field--wide': _ctx.wide}]),
          property: _ctx.field,
          value: _ctx.fixedValue,
          domain: _ctx.candidates,
          options: _ctx.options,
          "system-alias": _ctx.systemAlias,
          "idea-alias": _ctx.ideaAlias,
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setFixed($event))),
          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setFixed($event)))
        }, null, 8, ["class", "property", "value", "domain", "options", "system-alias", "idea-alias"]))
      : (_ctx.mode === 'formula')
        ? (_openBlock(), _createBlock(_component_ontos_formula_input, _mergeProps({
            key: 1,
            ref: "editor",
            class: "required property-default-formula"
          }, _ctx.bindings, {
            label: _ctx.$tt('default-mode.formula'),
            value: _ctx.formula,
            "default-formula": "",
            draft: _ctx.draft,
            "result-label": _ctx.resultLabel,
            example: _ctx.example,
            onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('input', {formula: $event}))),
            onValidity: _cache[4] || (_cache[4] = ($event: any) => (_ctx.valid = $event))
          }), null, 16, ["label", "value", "draft", "result-label", "example"]))
        : _createCommentVNode("", true)
  ]))
}